import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/useAuth';

const stats = [
  { value: '50K+', label: 'Nigerian Learners', icon: 'ri-group-line' },
  { value: '200+', label: 'Expert Courses', icon: 'ri-book-open-line' },
  { value: '95%', label: 'Completion Rate', icon: 'ri-trophy-line' },
  { value: '4.9★', label: 'Average Rating', icon: 'ri-star-fill' },
];

export default function HeroSection() {
  const { isAuthenticated } = useAuth();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=young%20Nigerian%20African%20students%20learning%20together%20in%20bright%20modern%20Lagos%20coworking%20space%20laptops%20tablets%20smiling%20engaged%20vibrant%20colourful%20productive%20atmosphere%20Nigerian%20flag%20colours%20green%20white&width=1440&height=900&seq=nghero1&orientation=landscape"
          alt="Nigerian students learning"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/92 via-slate-900/72 to-slate-900/25" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-20 pb-16">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-400/30 text-teal-300 text-sm font-medium px-4 py-1.5 rounded-full mb-6">
            <i className="ri-map-pin-line" />
            Built for Nigeria. Trusted across Africa.
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
            Learn the Skills That<br />
            <span className="text-teal-400">Naija Demands Today</span>
          </h1>

          <p className="text-lg text-slate-300 leading-relaxed mb-8 max-w-xl">
            From Lagos to Kano, Abuja to Port Harcourt — join thousands of Nigerians mastering tech, design, business, and digital skills to build careers and businesses that thrive.
          </p>

          <div className="flex flex-wrap items-center gap-4 mb-14">
            <Link
              to="/courses"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-teal-500 hover:bg-teal-400 text-white font-semibold rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line" />
              Explore Courses
            </Link>
            <Link
              to={isAuthenticated ? '/dashboard' : '/signup'}
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              {isAuthenticated ? 'Go to Dashboard' : 'Start for Free'}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-xl">
            {stats.map(stat => (
              <div key={stat.label} className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-xl p-3.5 text-center">
                <div className="w-7 h-7 flex items-center justify-center mx-auto mb-1.5">
                  <i className={`${stat.icon} text-teal-400 text-lg`} />
                </div>
                <div className="text-xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-slate-400 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
